import { jsx as _jsx } from "react/jsx-runtime";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { ThemeProvider } from '@mui/material/styles';
import './custom-checkbox.scss';
import CustomTheme from '../../../styles/theme';
const CustomCheckbox = (props) => {
    return (_jsx(ThemeProvider, { theme: CustomTheme, children: _jsx(FormControlLabel, { className: 'custom-checkbox', control: _jsx(Checkbox, { ...props, sx: {
                    borderRadius: '28px'
                } }), label: props.label }) }));
};
export default CustomCheckbox;
